import { apiClient } from "@/services/apiClient";
import type { Workspace, WorkspaceSummary } from "@/types/workspace";

export async function getMyWorkspaces(): Promise<WorkspaceSummary[]> {
  const res = await apiClient.get<WorkspaceSummary[]>("/api/workspace/mine");
  return res.data;
}

export async function getWorkspace(workspaceId: string): Promise<Workspace> {
  const res = await apiClient.get<Workspace>(`/api/workspace/${workspaceId}`);
  return res.data;
}

export async function getWorkspaceSummary(workspaceId: string): Promise<WorkspaceSummary> {
  const res = await apiClient.get<WorkspaceSummary>(`/api/workspace/${workspaceId}/summary`);
  return res.data;
}
